export default "__VITE_ASSET__0WELLgWq__"